// extracted by css-extract-rspack-plugin
export default {"shimmer":"_7e3a84ee","shimmerLoadingBackground":"_a2279766","row":"_dc151ee1","button":"_f01ab7bd","higherRow":"_9a67b4d8","hidePricingSeparator":"_be814f3e"};